import { DataBean } from "../DataBean";

export class TaxHoldvtwo extends DataBean {



    public async deleteTaxHold(idTaxHold: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteTaxHold_Number", [idTaxHold]);
    }

    public async getTaxHoldCatalog(args: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getTaxHoldCatalog_Number", [args]);
    }

}